import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({
  providedIn: "root",
})
export class CompetitiveWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    pk: string,
    competitive: boolean,
    token: string
  ): Observable<void> {
    const parameters = new HandlerBuilder()
      .setMethod(HttpMethod.post)
      .setUrl(ApiUrls.SET_COMPETITIVE_MATCH_ENDPOINT(pk))
      .setAuthorization(new TokenAuthorization(token))
      .setBody({
        competitive,
      })
      .build();
    return this.baseHandler.execute(parameters);
  }
}
